import type { FeedItems } from "../../../types/content/feedItem";

import { TeaserCluster } from "../../TeaserCluster/TeaserCluster";
import { InjectablePlaceholder } from "../../Injectable/Injectable";
import { isInjectable } from "../../../utils/typechecks";
import { FeedItemToTeaser } from "../utils/feedItemToTeaser";

const TopNewsLayout = ({
  data,
  isFirstFeed,
}: {
  data: FeedItems;
  isFirstFeed?: boolean;
}) => {
  let currentNrOfClusters = 0;

  return data.map((feedItem, index) => {
    if (!feedItem) return null;

    if (isInjectable(feedItem)) {
      return (
        <InjectablePlaceholder
          resource={feedItem}
          key={`${feedItem.type}${index}`}
        />
      );
    }

    const teaserWeight = feedItem.weight;

    currentNrOfClusters++;
    const isSmallCluster = feedItem.type === "Single";
    const isBox = feedItem.type === "Box";

    return (
      <TeaserCluster
        style={feedItem.style}
        header={feedItem.header}
        footer={feedItem.footer}
        key={`${feedItem.id}${index}`}
        isSmallCluster={isSmallCluster}
        isBox={isBox}
        teaserWeightValue={teaserWeight}
      >
        <FeedItemToTeaser
          feedItem={feedItem}
          positionInFeed={index}
          currentNrOfClusters={currentNrOfClusters}
          isFirstFeed={isFirstFeed}
        />
      </TeaserCluster>
    );
  });
};

export { TopNewsLayout };
